import { translate } from "game/translate";
import { GameUI } from "game/gameUI/GameUI";
import { Popups } from "ui/types/popups";

export const FacebookPopup = () => {
    const handleButtonClick = () => {
        GameUI.closePopup(Popups.FACEBOOK_POPUP, true);
    }

    const handleCloseClick = () => {
        GameUI.closePopup(Popups.FACEBOOK_POPUP);
    }

    return (
        <div id="facebook-banner" role="tooltip" className="modals_area active">
            <div className="wrapper">
                <button type="button" className="close_btn close" onClick={handleCloseClick}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("fb_banner_title")}</span>
                    <img loading="lazy" className="modals_area_img" src="/assets/fb_popup/fb-banner.webp" alt={translate("fb_banner_title")} />
                    <p className="modals_area-text">{translate("fb_banner_text_1")} <b>{translate("fb_banner_text_2")}</b> {translate("fb_banner_text_3")}</p>
                    <button type="button" className="modals_area-btn" onClick={handleButtonClick}>{translate("fb_banner_btn")}</button>
                </div>
            </div>
        </div>
    );
};
